import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import { MdOutlinePerson4 } from "react-icons/md";
import image13 from "../../Images/sweepydo_image13.jpg";
import { FaUser, FaPhone, FaEnvelope, FaMoneyBillWave } from "react-icons/fa";
import { MdWork, MdLocationOn } from "react-icons/md";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaBroom } from "react-icons/fa";
import { FaImagePortrait } from "react-icons/fa6";
function HireStaff() {
  const [showForm, setShowForm] = useState(false);
  const [preview, setPreview] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    aadhaar_file: null,
    mobile: "",
    email: "",
    address: "",
    profile_img: null,
    identity_file: null,
    doc_pan: null,
    latitude: "",
    longitude: "",
    gender: "",
    age: "",
    bank_name: "",
    acc_no: "",
    ifsc: "",
    holder_name: '',
    isActive: '',
    con_acc_no: ""
  });
  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "success"
  });
  const showToast = (msg, bg = "success") => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const genderOptions = [{
    value: "male",
    label: "Male"
  }, {
    value: "female",
    label: "Female"
  }, {
    value: "other",
    label: "Other"
  }];
  const handleInputChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const formatAddress = value => {
    if (!value) return null;
    const parts = value.split(",").map(p => p.trim());
    return {
      name: parts[0] || "",
      subLocality: parts[1] || "",
      locality: parts[2] || "",
      state: parts[3] || "",
      country: "India",
      pincode: parts[4] || ""
    };
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (!formData.name) {
      showToast("Name is required!", "danger");
      return;
    }
    if (!formData.mobile) {
      showToast("Mobile is required!", "danger");
      return;
    }
    if (!formData.email) {
      showToast("Email is required!", "danger");
      return;
    }

    // if (!formData.acc_no || !formData.con_acc_no) {
    //   showToast("Account number is required!", "danger");
    //   return;
    // }

    if (formData.acc_no !== formData.con_acc_no) {
      showToast("Account numbers do not match!", "danger");
      return;
    }
    try {
      const formattedAddress = formatAddress(formData.address);
      const sendData = new FormData();
      sendData.append("name", formData.name);
      sendData.append("mobile", formData.mobile);
      sendData.append("email", formData.email);
      sendData.append("pass", formData.pass || "");
      sendData.append("address", JSON.stringify(formattedAddress));
      sendData.append("gender", formData.gender || "");
      sendData.append("age", formData.age || "");
      sendData.append("bank_name", formData.bank_name || "");
      sendData.append("acc_no", formData.acc_no || "");
      sendData.append("ifsc", formData.ifsc || "");
      sendData.append("holder_name", formData.holder_name || "");
      sendData.append("basic_salary", formData.basic_salary || "");
      if (formData.profile_img) {
        const sizeMB = formData.profile_img.size / (1024 * 1024);
        if (sizeMB > 2) {
          showToast("Profile image must be under 2MB", "danger");
          return;
        }
        sendData.append("profile_img", formData.profile_img);
      }
      if (formData.aadhaar_file) {
        const file = formData.aadhaar_file;
        if (file.size / (1024 * 1024) > 2) {
          showToast(`File ${file.name} exceeds 2MB`, "danger");
          return;
        }
        sendData.append("identity_file", formData.aadhaar_file);
      }
      if (formData.doc_pan) {
        const file = formData.doc_pan;
        if (file.size / (1024 * 1024) > 2) {
          showToast(`File ${file.name} exceeds 2MB`, "danger");
          return;
        }
        sendData.append("doc_pan", file);
      }
      // for (let pair of sendData.entries()) {
      //   // console.log(pair[0], pair[1]);
      // }

      // console.log("===== FormData Debug End =====");

      await axios.post("https://api.sweepydo.in/add-staff", sendData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      showToast("Request Submitted Successfully!", "success");
      resetForm();
      setShowForm(false);
    } catch (err) {
      console.error(" Error:", err.response?.data || err.message);
      showToast("Failed to submit!", "danger");
    }
  };
  const resetForm = () => {
    setFormData({
      name: "",
      aadhaar_file: null,
      mobile: "",
      email: "",
      address: "",
      profile_img: null,
      identity_file: null,
      doc_pan: null,
      latitude: "",
      longitude: "",
      gender: "",
      age: "",
      bank_name: "",
      acc_no: "",
      ifsc: "",
      holder_name: "",
      isActive: "",
      con_acc_no: "",
      basic_salary: "",
      pass: ""
    });
    setPreview(null);
  };
  return <>
          <section className="d-flex flex-column flex-md-row align-items-center justify-content-between" style={{
      minHeight: "260px",
      // height: "220px",
      color: "#121313",
      padding: "20px clamp(20px, 5vw, 60px)",
      backgroundImage: `url(${image13})`,
      backgroundSize: "cover",
      backgroundPosition: "center top",
      backgroundRepeat: "no-repeat",
      backgroundColor: "#f5f5f5",
      position: "relative",
      overflow: "hidden",
      fontFamily: "'Montserrat', sans-serif",
      height: "450px"
    }}>
  <div style={{
        position: "absolute",
        inset: 0,
        backgroundColor: "rgba(255, 255, 255, 0.45)",
        zIndex: 0
      }}></div>


  <div style={{
        position: "relative",
        zIndex: 1,
        flex: 1,
        textAlign: "center",
        marginBottom: "10px"
      }}>
    <h1 className="fw-bold" style={{
          fontSize: "clamp(34px, 4vw, 58px)",
          margin: 0,
          fontWeight: "700"
        }}>
      Hire Staff
    </h1>
  </div>

 
  <div style={{
        position: "relative",
        zIndex: 1,
        flex: 1,
        textAlign: "center"
      }}>
    <div style={{
          fontSize: "clamp(14px, 1.2vw, 16px)",
          color: "#555",
          fontWeight: "500"
        }}>
      <span style={{
            cursor: "pointer",
            color: "#6A20Af"
          }} onClick={() => window.location.href = "/"}>
        Home
      </span>{" "}
      &gt; <span>HireStaff</span>
    </div>
  </div>
</section>
    <div className="container mt-4 mb-4">
      <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
        ...toast,
        show: false
      })} />

    
      {!showForm && <div className="text-center p-5" style={{
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.08)"
      }}>
     <h2 className="mb-3" style={{
          color: "#6A20Af"
        }}>
  <FaBroom className="me-2" />
  Join Sweepydo Cleaning Team
</h2>

          <p style={{
          color: "#555",
          maxWidth: "600px",
          margin: "auto"
        }}>
            Start your journey with Sweepydo and earn by providing professional
            home cleaning services. Work flexibly, earn regularly, and grow with us.
          </p>

          <div className="mt-4 text-start" style={{
          maxWidth: "400px",
          margin: "auto"
        }}>
            <p><IoMdCheckmarkCircleOutline color="Purple " /> Flexible working hours</p>
            <p><IoMdCheckmarkCircleOutline color="Purple " /> Regular income</p>
            <p><IoMdCheckmarkCircleOutline color="Purple " /> Nearby jobs</p>
            <p><IoMdCheckmarkCircleOutline color="Purple " /> Safe & trusted platform</p>
          </div>

          <Button className="mt-4 px-4 py-2" onMouseEnter={e => {
          e.target.style.backgroundColor = "#c55DF8";
          e.target.style.color = "#000";
        }} onMouseLeave={e => {
          e.target.style.backgroundColor = "#6A20Af";
          e.target.style.color = "#fff";
        }} onClick={() => setShowForm(true)} style={{
          borderRadius: "30px",
          background: "#6A20Af",
          border: "none"
        }}>
            Apply Now
          </Button>
        </div>}


      {showForm && <Card className="p-4 mt-3" style={{
        borderRadius: "12px",
        boxShadow: "0 8px 25px rgba(0,0,0,0.08)"
      }}>
          <div className="text-center">
  <h4 className="mb-2" style={{
            color: "#6A20Af"
          }}>Apply as Cleaning Staff </h4>
  <p style={{
            color: "#666"
          }}>
    Fill your details and our team will contact you shortly.
  </p>
</div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4 text-center">
  {preview ? <img src={preview} alt="Profile" style={{
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #6A20Af"
            }} /> : <div style={{
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              backgroundColor: "#e0e0e0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "auto"
            }}>
      <FaUser size={50} color="#555" />
    </div>}
</div>
       <div className="row">


  <div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
  
    <label className="d-flex align-items-center gap-2">
      <FaUser color="#6A20Af" /> Name
    </label>
    <input type="text" name="name" className="form-control light-input" placeholder="Enter your name" value={formData.name} onChange={handleInputChange} required />
  </div>


  <div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
      
    <label className="d-flex align-items-center gap-2">
      <FaPhone color="#6A20Af" /> Phone
    </label>
    <input type="text" name="mobile" className="form-control light-input" placeholder="Enter mobile number" value={formData.mobile} onChange={handleInputChange} required />
  </div>

  
  <div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
     
    <label className="d-flex align-items-center gap-2">
      <FaEnvelope color="#6A20Af" /> Email
    </label>
 <input type="email" name="email" className="form-control light-input" placeholder="Enter email" value={formData.email} onChange={handleInputChange} required />
  </div>

 
  <div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
      
    <label className="d-flex align-items-center gap-2">
      <MdWork color="#6A20Af" /> Age
    </label>
   <input type="number" name="age" className="form-control light-input" placeholder="Enter age" value={formData.age} onChange={handleInputChange} min="18" max="65" required />
  </div>

  
  <div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
      
    <label className="d-flex align-items-center gap-2">
      <MdOutlinePerson4 color="#6A20Af" /> Gender
    </label>
<Select options={genderOptions} placeholder="Select gender" onChange={e => setFormData({
                ...formData,
                gender: e.value
              })} styles={{
                control: (base, state) => ({
                  ...base,
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  borderColor: state.isFocused ? "#6A20Af" : "#ccc",
                  boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(150, 43, 182, 0.25)" : "none",
                  "&:hover": {
                    borderColor: "#6A20Af"
                  }
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? "#6A20Af" : state.isFocused ? "#f0d4f5" : "#fff",
                  color: state.isSelected ? "#fff" : "#000",
                  cursor: "pointer"
                })
              }} required />
  </div>

  
  <div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>

    <label className="d-flex align-items-center gap-2">
      <FaMoneyBillWave color="#6A20Af" /> Bank Name
    </label>
    <input type="text" name="bank_name" className="form-control light-input" placeholder="Enter bank name" value={formData.bank_name} onChange={handleInputChange} required />
  </div>


  <div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
   
    <label className="d-flex align-items-center gap-2">
      <FaMoneyBillWave color="#6A20Af" /> Account No
    </label>
    <input type="text" name="acc_no" className="form-control light-input" placeholder="Enter account number" value={formData.acc_no} onChange={handleInputChange} required />
  </div>

  
  <div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
  
    <label className="d-flex align-items-center gap-2">
      <FaMoneyBillWave color="#6A20Af" /> Confirm Account
    </label>
    <input type="text" name="con_acc_no" className="form-control light-input" placeholder="Confirm account number" value={formData.con_acc_no} onChange={handleInputChange} />
  </div>


  <div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
    <label className="d-flex align-items-center gap-2">
      <FaMoneyBillWave color="#6A20Af" /> IFSC Code
    </label>
    <input type="text" name="ifsc" className="form-control light-input" placeholder="Enter IFSC code" value={formData.ifsc} onChange={handleInputChange} required />
  </div>

  <div className="col-md-12 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
    <label className="d-flex align-items-center gap-2">
      <MdLocationOn color="#6A20Af" /> Address
    </label>
    <textarea name="address" className="form-control light-input" rows={3} placeholder="Enter your address" value={formData.address} onChange={handleInputChange} required />
  </div>
  {/* Account Holder Name */}
<div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
  <label className="d-flex align-items-center gap-2">
    <FaUser color="#6A20Af" /> Account Holder Name
  </label>
  <input type="text" name="holder_name" className="form-control light-input" placeholder="Enter account holder name" value={formData.holder_name} onChange={handleInputChange} />
</div>

<div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
   <label className="d-flex align-items-center gap-2">
    <FaImagePortrait color="#6A20Af" /> Upload Profile Image
  </label>

<input type="file" name="profile_img" className="form-control light-input" accept="image/*"
              // style={{ width: "300px" }}   
              onChange={e => {
                const file = e.target.files[0];
                setFormData({
                  ...formData,
                  profile_img: file
                });
                if (file) {
                  setPreview(URL.createObjectURL(file));
                }
              }} required />
</div>



{/* Aadhaar Card Upload */}
<div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
  <label className="d-flex align-items-center gap-2">
    <FaMoneyBillWave color="#6A20Af" /> Aadhaar Card
  </label>
  <input type="file" name="aadhaar_file" className="form-control light-input" accept="image/*,.pdf" onChange={e => setFormData({
                ...formData,
                aadhaar_file: e.target.files[0]
              })} required />
</div>

<div className="col-md-6 mb-3" style={{
              fontFamily: "Open Sans, sans-serif"
            }}>
  <label className="d-flex align-items-center gap-2">
    <FaMoneyBillWave color="#6A20Af" /> Pan
  </label>
  <input type="file" name="doc_pan" className="form-control light-input" accept="image/*,.pdf" onChange={e => setFormData({
                ...formData,
                doc_pan: e.target.files[0]
              })} required />
</div>

              <div className="d-flex justify-content-end">
           <Button type="submit" variant="success" onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = "#c55DF8";
                e.currentTarget.style.color = "#000";
              }} onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = "#6A20Af";
                e.currentTarget.style.color = "#fff";
              }} style={{
                backgroundColor: "#6A20Af",
                color: "#fff",
                border: "none",
                padding: "8px 20px"
              }}>
  Submit
</Button>
                <Button variant="secondary" className="ms-2" onClick={() => setShowForm(false)}>
                  Back
                </Button>
              </div>

            </div>
          </form>

          <p style={{
          fontSize: "12px",
          color: "#888",
          marginTop: "10px"
        }}>
            Your information is safe with us. We only use it for hiring purposes.
          </p>
        </Card>}
    </div>
    </>;
}
export default HireStaff;
